export function isUndefined(value) {
    return value === void 0;
}
